export default "__VITE_ASSET__B1FT66hK__"